<template>
  <div class="shadow sm:rounded-md bg-white p-4">
    <div class="space-y-8 divide-y divide-gray-200">
      <div :class="{ '-grid': !!grid }">
        <slot />
      </div>
    </div>
  </div>
</template>

<style scoped>
.-grid :deep(form) {
  @apply grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6;
}
:deep(.section) {
  @apply border-t border-gray-200 col-span-6 grid grid-cols-6 gap-4 items-start py-5;

  &:first-child {
    @apply border-0;
  }
}
</style>

<script>
export default {
  props: {
    grid: Boolean,
    required: false,
  }
}
</script>
